import { createContext } from 'react';
import axios from 'axios';
import { ClientConfig } from '../types/serverConfig';

export const ClientConfigContext = createContext<ClientConfig>({
    tier: '',
    title: '',
    pimsApiUrl: '',
    b2cTenantConfig: {
        scopes: [] as string[],
        tenantName: '',
        signInPolicy: '',
        clientId: '',
        redirectUri: '',
        postLogoutRedirectUri: '',
    },
    multiEhr: {
        prefix: '',
        epicInstances: [],
        labels: [],
    },
    theming: {
        brandName: '',
        emailBrand: '',
        logoUri: '',
        logoAltText: '',
        theme: {
            palette: {
                text: { primary: '' },
                primary: { main: '', border: '' },
                secondary: { main: '' },
                regionColor: [],
            },
            overrides: {},
        },
    },
    userActivityLimitSeconds: 3600,
});

export function createConfiguredApp(callback: any, loginTenant?: string) {
    axios
        .get(`/api/config?loginTenant=${loginTenant}`)
        .then(callback)
        .catch((err: any) => console.log(err));
}
